import { create } from "zustand";

// Persisted in a store (not a one-shot window event) because the service worker can
// report a waiting update before React has mounted the toast that displays it.
export const usePwaUpdateStore = create((set) => ({
  needRefresh: false,
  updateSW: null,

  setNeedRefresh: (needRefresh) => set({ needRefresh }),
  setUpdateSW: (updateSW) => set({ updateSW }),
}));
